import * as React from 'react';

export default function PlusCircle({
  viewBox = '0 0 12.8 12.8',
  ...rest
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.4 12.8C9.93462 12.8 12.8 9.93462 12.8 6.4C12.8 2.86538 9.93462 0 6.4 0C2.86538 0 0 2.86538 0 6.4C0 9.93462 2.86538 12.8 6.4 12.8ZM7.19999 4C7.19999 3.55817 6.84182 3.2 6.4 3.2C5.95817 3.2 5.6 3.55817 5.6 4V5.6H4C3.55817 5.6 3.2 5.95817 3.2 6.4C3.2 6.84183 3.55817 7.2 4 7.2H5.6V8.8C5.6 9.24183 5.95817 9.6 6.4 9.6C6.84182 9.6 7.19999 9.24183 7.19999 8.8V7.2H8.79999C9.24182 7.2 9.59999 6.84183 9.59999 6.4C9.59999 5.95817 9.24182 5.6 8.79999 5.6H7.19999V4Z"
        fill="currentColor"
      />
    </svg>
  );
}
